import { Component, ElementRef, inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { SettlementsService } from 'src/app/services/settlements.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { TasksService } from 'src/app/services/tasks.service';
import { IconsService } from 'src/app/shared/services/icons.service';
import { CatalogsService } from 'src/app/shared/services/catalogs.service';
import { TextService } from 'src/app/shared/services/text.service';
import { NgbDate, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalSkillsComponent } from 'src/app/components/modals/modal-skills.component';
import { ModalToolsComponent } from 'src/app/components/modals/modal-tools.component';
import { ModalVehiclesComponent } from 'src/app/components/modals/modal-vehicles.component';
import { ModalWorkScheduleComponent } from 'src/app/components/modals/modal-work-schedule.component';
import { ModalUserPasswordComponent } from 'src/app/components/modals/modal-user-password.component';
import { ModalUserFormComponent } from 'src/app/components/modals/modal-user-form.component';
import { debounceTime, distinct, distinctUntilChanged, switchMap } from 'rxjs';
import { ngxCsv } from 'ngx-csv/ngx-csv';
import { User } from 'src/app/models/user';
import { AuthService } from 'src/app/shared/services/auth.service';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-technicians',
  template: `
    <div class="d-flex mt-0 mt-md-4">
      <div class="flex-fill">
        <h1 class="mt-2 mt-md-0">Tareas y técnicos</h1>
        <xng-breadcrumb ></xng-breadcrumb>
      </div>
    </div>
    <div class="d-flex mt-4">
      <div class="me-3 d-none d-md-block">        
        <ul #subnav app-nav-tasks [currentView]="currentView" class="sidebar-zazz list-unstyled"></ul>
      </div>
      <div class="flex-fill ms-auto">
        <div class="d-flex mb-3">
          <div class="flex-fill ms-2">
            <h2 class="mt-2 mt-md-0 mb-0">Técnicos</h2>
          </div>
          <div>
            <button class="btn btn-zazz-dark rounded-2 border-2" *ngIf="authService.hasPermission('can_create_technicians')" (click)="createUser()">
              <fa-icon [icon]="icons.faPlus" class="me-2"></fa-icon>
              Agregar técnico
            </button>
          </div>
        </div>
        <div class="card rounded-4 border border-1 overflow-hidden">
          <div class="card-body p-0">
            <div class="d-flex">
              <div class="">                
                <div class="list-group rounded-0">
                  <div class="list-group-item border-end-0">
                    <input class="form-control bg-transparent" placeholder="Buscar..." [formControl]="searchControl">
                  </div>
                  <div class="list-group-item list-group-item-action list-group-item-light border-end-0 py-2" 
                    *ngFor="let user of technicians | paginate: { itemsPerPage: payload.per_page, currentPage: p, totalItems: meta.total_entries }" 
                    (click)="selectTechnician(user)"
                    [ngClass]="user.id == selectedTechnician?.id ? 'active' : ''"
                  >
                    <p class="mb-0" style="line-height: 1;">{{user.name}} {{user.last_name}}</p>
                    <p class="text-muted text-sm mb-0">{{ textService.truncateTextAtWord(user.email, 24)}}</p>
                  </div>
                  <div class="list-group-item text-center py-5 border-end-0" *ngIf="technicians.length==0&&loading">
                    <fa-icon [icon]="icons.faCircleNotch" size="2x" animation="spin" class="text-secondary"></fa-icon>
                    <p class="text-muted">Cargando...</p>
                  </div>
                  <div class="list-group-item text-center border-start-1 py-5 border-end-0" *ngIf="technicians.length==0&&!loading">
                    <img src="/assets/images/empty-state.png" width="240px">
                    <h5 class="text-muted">No se encontraron registros</h5>
                  </div>
                  <div class="list-group-item text-center border-end-0 pt-4" >
                    <pagination-controls
                      (pageChange)="p = $event"
                      (pageChange)="pageChanged($event)"
                      previousLabel="Prev."
                      nextLabel="Sig."
                      screenReaderPaginationLabel="Pagination"
                      screenReaderPageLabel="page"
                      *ngIf="technicians.length>0"
                      class="text-sm"
                    ></pagination-controls>
                  </div>
                </div>
              </div>

              <div class="flex-fill">
                <div *ngIf="selectedTechnician">
                  <div class="list-group border-0 rounded-0" *ngIf="!reportView">
                    <div class="list-group-item py-3 border-end-0 border-bottom-0 border-top-0">
                      <div class="d-flex">
                        <div>
                          <h4 class="mb-1"><span *ngIf="summary?.avg">{{summary?.avg | number: '1.2-2' }} </span> <span *ngIf="!summary?.avg"> - </span> <fa-icon [icon]="icons.faStar" class="text-warning"></fa-icon></h4>
                          <!-- p class="mb-1"><span class="ms-0">{{summary?.complete}} Completadas</span> <span class="ms-2">{{summary?.pending}} No completadas</span></!-->
                          <p class="mb-0"><strong>{{selectedTechnician.name}} {{selectedTechnician.last_name}} {{selectedTechnician.last_name_m}}</strong></p>
                          <p class="mb-0">{{selectedTechnician.email}}</p>
                          <p class="mb-0">{{selectedTechnician.phone}}</p>
                          <p class="mb-0">
                            <span *ngIf="selectedTechnician.employee_number">{{selectedTechnician.employee_number}}</span>
                            <span class="text-muted" *ngIf="!selectedTechnician.employee_number">Número de empleado no asignado</span>
                          </p>
                          <p class="mb-0">
                            <span *ngIf="selectedTechnician.licence_type">{{selectedTechnician.licence_type}} - {{selectedTechnician.licence}}</span>
                            <span class="text-muted" *ngIf="!selectedTechnician.licence_type">No se encontró licencia</span>
                          </p>
                        </div>
                        <div class="ms-auto text-end">
                          <button class="btn btn-outline-primary btn-sm" (click)="reportView=!reportView">Reportes</button><br>
                          <button class="btn btn-outline-secondary btn-sm mt-4" (click)="updateUser()">Editar</button><br>
                          <button class="btn btn-outline-warning btn-sm mt-3" (click)="updatePassword()">Cambiar contraseña</button>
                        </div>
                      </div>                      
                    </div>
                    <div class="list-group-item py-3">
                      <div class="d-flex">
                        <div>
                          <h5>Vehículo Asignado</h5>
                          <p class="mb-0" *ngIf="vehicle">{{vehicle.name}} - {{vehicle.marca}} {{vehicle.modelo}}</p>
                          <p class="text-muted" *ngIf="!vehicle">No se encontró vehículo asignado.</p>
                        </div>
                        <div class="ms-auto">
                          <button class="btn btn-outline-secondary btn-sm"  (click)="addVehicle()">Editar</button>
                        </div>
                      </div>
                      
                      <div class="d-flex">
                        <div class="mt-4">
                          <h5>Habilidades</h5>
                          <ul class="list-unstyled" *ngIf="asignedSkills.length>0">
                            <li *ngFor="let skill of asignedSkills">{{skill?.name}}</li>
                          </ul>
                          <p class="text-muted" *ngIf="asignedSkills.length==0">No se encontraron habilidades asignadas.</p>
                        </div>
                        <div class="ms-auto mt-3">
                          <button class="btn btn-outline-secondary btn-sm" (click)="addSkills()">Asignar</button>
                        </div>
                      </div>
                      
                      <div class="d-flex">
                        <div class="mt-3">
                          <h5>Herramientas</h5>
                          <ul class="list-unstyled" *ngIf="tools.length>0">
                            <li *ngFor="let tool of tools">{{tool.name}}</li>
                          </ul>
                          <p class="text-muted" *ngIf="tools.length==0">No se encontraron herramientas asignadas.</p>
                        </div>
                        <div class="ms-auto">
                          <button class="btn btn-outline-secondary btn-sm" (click)="addTools()">Asignar</button>
                        </div>
                      </div>
                      
                    </div>
                    <div class="list-group-item py-3">
                      <div class="d-flex">
                        <div class="" style="width: 85%;">
                          <h5 class="mt-2">Horario laboral</h5>
                          <table class="table table-sm table-striped w-100" style="font-size: 0.9em;">
                            <tr class="border-bottom">
                              <th colspan="4">Día</th>
                              <th colspan="1" class="text-end">Inicio</th>
                              <th colspan="1" class="text-end">Fin</th>
                            </tr>
                            <tr class="border-bottom">
                              <td colspan="4">Lunes</td>
                              <td colspan="1" class="text-end">{{work_schedule?.monday_start ? work_schedule?.monday_start + ':00' : '-'}}</td>
                              <td colspan="1" class="text-end">{{work_schedule?.monday_end ? work_schedule?.monday_end + ':00' : '-'}}</td>
                            </tr>
                            <tr class="border-bottom">
                              <td colspan="4">Mares</td>
                              <td colspan="1" class="text-end">{{work_schedule?.tuesday_start ? work_schedule?.tuesday_start + ':00' : '-'}}</td>
                              <td colspan="1" class="text-end">{{work_schedule?.tuesday_end ? work_schedule?.tuesday_end + ':00' : '-'}}</td>
                            </tr>
                            <tr class="border-bottom">
                              <td colspan="4">Miércoles</td>
                              <td colspan="1" class="text-end">{{work_schedule?.wednesday_start ? work_schedule?.wednesday_start + ':00' : '-'}}</td>
                              <td colspan="1" class="text-end">{{work_schedule?.wednesday_end ? work_schedule?.wednesday_end + ':00' : '-'}}</td>
                            </tr>
                            <tr class="border-bottom">
                              <td colspan="4">Jueves</td>
                              <td colspan="1" class="text-end">{{work_schedule?.thursday_start ? work_schedule?.thursday_start + ':00' : '-'}}</td>
                              <td colspan="1" class="text-end">{{work_schedule?.thursday_end ? work_schedule?.thursday_end + ':00' : '-'}}</td>
                            </tr>
                            <tr class="border-bottom">
                              <td colspan="4">Viernes</td>
                              <td colspan="1" class="text-end">{{work_schedule?.friday_start ? work_schedule?.friday_start + ':00' : '-'}}</td>
                              <td colspan="1" class="text-end">{{work_schedule?.friday_end ? work_schedule?.friday_end + ':00' : '-'}}</td>
                            </tr>
                            <tr class="border-bottom">
                              <td colspan="4">Sábado</td>
                              <td colspan="1" class="text-end">{{work_schedule?.saturday_start ? work_schedule?.saturday_start + ':00' : '-'}}</td>
                              <td colspan="1" class="text-end">{{work_schedule?.saturday_end ? work_schedule?.saturday_end + ':00' : '-'}}</td>
                            </tr>
                            <tr class="border-bottom">
                              <td colspan="4">Domingo</td>
                              <td colspan="1" class="text-end">{{work_schedule?.sunday_start ? work_schedule?.sunday_start + ':00' : '-'}}</td>
                              <td colspan="1" class="text-end">{{work_schedule?.sunday_end ? work_schedule?.sunday_end + ':00' : '-'}}</td>
                            </tr>
                          </table>
                        </div>
                        <div class="ms-auto">
                          <button class="btn btn-outline-secondary btn-sm" (click)="editSchedule()">Editar</button>
                        </div>
                      </div>
                    </div>
                    <div class="list-group-item py-3">
                      <table class="table table-sm table-borderless w-100" *ngIf="selectedTasks.length>0" style="font-size: 0.9em;">
                        <thead>
                          <th colspan="6" class="text-start">Tarea asignada</th>
                          <th colspan="2" class="text-center">Programada</th>
                          <th colspan="2" class="text-center">Completada</th>             
                          <th colspan="2" class="text-center">Estatus</th>
                        </thead>
                        <tbody>
                          <tr *ngFor="let task of selectedTasks | paginate: { itemsPerPage: task_config.per_page, currentPage: task_p, totalItems: tasksMeta.total_entries }">
                            <td colspan="2">
                              <a routerLink="/maintenances/tasks/review/{{task.id}}" *ngIf="task.completed"># {{task.id}}</a>
                              <strong *ngIf="!task.completed"># {{task.id}}</strong>
                            </td>
                            <td colspan="4">{{getBuilder(task).name}}</td>
                            <td colspan="2" class="text-center">{{task?.due_date | date: 'dd/MM/yy'}}</td>
                            <td colspan="2" class="text-center">
                              <span *ngIf="task.completed_at">{{task.completed_at | date: 'dd/MM/yy HH:mm '}}</span>
                              <span *ngIf="!task.completed_at">--</span>
                            </td>
                            <td colspan="2" class="text-end"><span class="badge badge-pill rounded-5 mb-0 px-3 py-1 me-2" [ngStyle]="{ background: getStatus(task).color, color: getStatus(task).text}">{{ getStatus(task).name }}</span></td>
                          </tr>
                        </tbody>
                      </table>
                      <div *ngIf="selectedTasks.length==0" class="text-center">
                        <p class="text-muted mt-2">No se encontraron tareas asignadas.</p>
                      </div>

                      <div class="text-end mt-3" >
                        <pagination-controls
                          (pageChange)="task_p = $event"
                          (pageChange)="taskPageChanged($event)"
                          previousLabel="Prev."
                          nextLabel="Sig."
                          screenReaderPaginationLabel="Pagination"
                          screenReaderPageLabel="page"
                          *ngIf="selectedTasks.length>0"
                          class="text-sm"
                        ></pagination-controls>
                      </div>
                    </div>
                  </div>

                  <div class="list-group" *ngIf="reportView">
                    <div class="list-group-item py-3">
                      <div class="d-flex">
                        <div>
                          <h4 class="mb-1"><span *ngIf="summary?.avg">{{summary?.avg | number: '1.2-2' }} </span> <span *ngIf="!summary?.avg"> - </span> <fa-icon [icon]="icons.faStar" class="text-warning"></fa-icon></h4>
                          <p class="mb-1"><span class="ms-0">{{summary?.complete}} Completadas</span> <span class="ms-2">{{summary?.pending}} No completadas</span></p>
                          <p class="mb-0"><strong>{{selectedTechnician.name}} {{selectedTechnician.last_name}}</strong></p>
                          <p class="mb-0">{{selectedTechnician.email}}</p>
                          <p class="mb-0">{{selectedTechnician.phone}}</p>
                        </div>
                        <div class="ms-auto text-end">
                          <button class="btn btn-outline-primary btn-sm" (click)="reportView=!reportView">Cerrar</button><br>
                        </div>
                      </div>                      
                    </div>
                    <div class="list-group-item py-3">
                      <div class="d-flex ms-auto mb-4 mt-2">
                        <div class="ms-auto">
                          <div class="btn-group" role="group" aria-label="Basic example">
                            <button #1mes type="button" class="btn btn-sm btn-outline-secondary" (click)="updateFilter(1)">1 mes</button>
                            <button #3mes type="button" class="btn btn-sm btn-outline-secondary" (click)="updateFilter(3)">3 meses</button>
                            <button #6mes type="button" class="btn btn-sm btn-outline-secondary" (click)="updateFilter(6)">6 meses</button>
                            <button #12mes type="button" class="btn btn-sm btn-outline-secondary active" (click)="updateFilter(12)">1 año</button>
                            <button #custo type="button" class="btn btn-sm btn-outline-secondary">Filtrar</button>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex">
                        <table class="table table-sm table-striped" style="font-size: 0.9em;">
                          <tr class="border-bottom">
                            <th>#</th>
                            <th>Tarea</th>
                            <th class="text-center">Calificación</th>
                            <th class="text-center">Fecha</th>
                            <th class="text-center">Condominio</th>
                            <th class="text-center">Completada</th>
                          </tr>
                          <tr *ngFor="let grade of grades">
                            <td><a routerLink="/maintenances/tasks/review/{{grade.task?.id}}"># {{grade.task?.id}}</a></td>
                            <td>{{grade.task?.name}}</td>
                            <td class="text-center">{{grade.avg_grade | number : '1.2-2'}}</td>
                            <td>{{grade.task?.due_date | date: 'dd/MM/YY'}}</td>
                            <td class="text-center">{{grade.settlement?.name}}</td>
                            <td class="text-center">{{grade.task?.completed_at | date: 'dd/MM/YY HH:mm' }}</td>
                          </tr>
                        </table>
                      </div>
                      <div class="ms-auto text-end mt-3">
                        <button class="btn btn-outline-primary" [disabled]="grades.length==0 || downloading" (click)="downloadReport()">Generar reporte</button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="list-group rounded-0" *ngIf="!selectedTechnician">
                  <div class="list-group-item text-center py-5 border-end-0 border-bottom-0 border-top-0" style="height: 500px;">
                    <img src="/assets/images/empty-state.png" width="240px">
                    <p class="text-muted">No hay técnico seleccionado</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <app-modal-work-schedule [technician]="selectedTechnician" [work_schedule]="work_schedule" [profile]="profile" (updateDismiss)="updateDismissed()"></app-modal-work-schedule>    
    <app-modal-vehicles [technician]="selectedTechnician" [profile]="profile" (vehicleData)="updateVehicle($event)" (updateDismiss)="updateDismissed()"></app-modal-vehicles>
    <app-modal-tools [technician]="selectedTechnician" [profile]="profile" (updateDismiss)="updateDismissed()"></app-modal-tools>
    <app-modal-skills [technician]="selectedTechnician" [profile]="profile" (updateDismiss)="updateDismissed()"></app-modal-skills>
    <app-modal-user-password [user]="selectedTechnician" (updateDismiss)="updateDismissed()"></app-modal-user-password>
    <app-modal-user-form [user]="selectedTechnician" [profile]="profile" (updateDismiss)="updateDismissed()"></app-modal-user-form>
  `,
  styleUrls: []
})
export class TechniciansComponent implements OnInit {

  loading: boolean = false;
  loadingTechnician: boolean = false;
  downloading: boolean = false;
  technicians: User[] = [];
  meta: any = {};
  // searchBox: FormGroup = new FormGroup({});
  searchControl = new FormControl();
  profile: any = {};
  permissions: any = {};

  selectedTechnician: any = null;
  selectedTasks: any[] = [];
  tasksMeta: any = {};
  vehicle: any = {};
  skills: any[] = [];
  asignedSkills: any[] = [];
  tools: any[] = [];
  work_schedule: any = {};

  currentView: string = 'technicians';

  status: any;
  summary: any = {};

  builders: any[] = [];
  taskCategories: any[] = [];

  grades: any = [];

  payload: any = {
    page: 1,
    per_page: 10,
    role_id: 3
  };

  task_config: any = {
    page: 1,
    per_page: 10
  }

  reportView: boolean = false;

  p: number = 1;
  task_p: number = 1;
  period: number = 1;

  @ViewChild(ModalSkillsComponent, { static: true }) modalSkillsComponent!: ModalSkillsComponent;
  @ViewChild(ModalToolsComponent, { static: true }) modalToolsComponent!: ModalToolsComponent;
  @ViewChild(ModalVehiclesComponent, { static: true }) modalVehiclesComponent!: ModalVehiclesComponent;
  @ViewChild(ModalWorkScheduleComponent, { static: true }) modalWorkScheduleComponent!: ModalWorkScheduleComponent;
  @ViewChild(ModalUserPasswordComponent, { static: true }) modalUserPasswordComponent!: ModalUserPasswordComponent;
  @ViewChild(ModalUserFormComponent, { static: true }) modalUserFormComponent!: ModalUserFormComponent;
  @ViewChild('1mes') oneMonth !: ElementRef;
  @ViewChild('3mes') threeMonth !: ElementRef;
  @ViewChild('6mes') sixMonth !: ElementRef;
  @ViewChild('12mes') twelveMonth !: ElementRef;

  a = new Date();
  fromDate: any; // = "2023/12/01"; // Date = new Date();
  toDate: any; // = "2024/02/02"; // Date = new Date();

  query: any = {
    unit_id: 0,
    date_from: '',
    date_to: '',
  };
  storageService = inject(StorageService);
  constructor(
    private store: SettlementsService,
    private tasks: TasksService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    public icons: IconsService,
    private catalog: CatalogsService,
    public textService: TextService,
    private modalService: NgbModal,
    public authService: AuthService
  ) {
    this.profile = this.storageService.getItem(STORAGE_KEYS.PROFILE) ? this.storageService.getItem(STORAGE_KEYS.PROFILE).profile : null;
    this.permissions = this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) ? this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) : null;
    this.payload.profile_id = this.profile.id;

    const today = new Date();
    today.setMonth(today.getMonth() - 12);
    const adjustedDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    const testDate = new Date(this.a.getFullYear(), 1, 15); // February 15, 2025 (months are 0-indexed)
    const lastDay = new Date(testDate.getFullYear(), testDate.getMonth() + 1, 0);

    this.fromDate = new NgbDate(adjustedDate.getFullYear(), adjustedDate.getMonth()+1, 1);
    this.toDate = new NgbDate(this.a.getFullYear(), this.a.getMonth()+1, lastDay.getDate());

    this.query.date_from = `${this.fromDate?.year}-${this.fromDate?.month}-${this.fromDate?.day}`;
    this.query.date_to = `${this.toDate?.year}-${this.toDate?.month}-${this.toDate?.day}`;
  }

  ngOnInit() {    
    this.loadUsers(this.payload);
    this.loadBuilders();

    this.searchControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(query => this.store.getUsers({ page: 1, per_page: 10, name: query, role_id: 3, profile_id: this.profile.id }))
    ).subscribe((results: any) => {
      this.technicians = results.data;
      this.meta = results.meta;
    });
  }

  getStatus(task: any) {
    return this.catalog.status[task.status];
  }

  getBuilder(task: any) {
    // console.log('task.builder_id => ', this.builders);
    if (this.builders) {
      return this.builders.find((builder: any) => builder.id == task.builder_id);
    } else {
      return {};
    }
  }

  loadBuilders() {
    this.tasks.getBuilders({ page: 1, per_page: 100}).subscribe((cat: any) => {
      this.builders = cat.data;
      this.taskCategories = cat.data;
    });  
  }

  loadUsers(payload: any) {
    this.loading = true;
    this.store.getUsers(payload).subscribe({
      next: (technicians: any) => {
        console.log(technicians);
        this.technicians = technicians.data;
        this.meta = technicians.meta;
        this.loading = false;
      },
      error: (err: any) => {
        console.log(err);
        this.technicians = [];
        this.loading = false;
      }
    });
  }

  async selectTechnician(technician: any) {
    console.log('selected technician => ', technician);
    this.loadingTechnician = true;
    this.selectedTechnician = technician;
    this.query.id = this.selectedTechnician.id;
    await this.loadTasks(technician.id);
    await this.loadAsignedVehicle(technician.id);
    await this.loadSkills(technician.id);
    await this.loadTools(technician.id);
    await this.loadStats(technician.id);
    this.loadWorkSchedule(technician.id);

    // this.loadingTechnician = false;
  }

  async loadTasks(id: any) {
    this.task_config.assignee_id = id;
    this.tasks.getTasks(this.task_config).subscribe({
      next: (tasks: any) => {
      this.selectedTasks = tasks.data;
      this.tasksMeta = tasks.meta;
      }, error: (err: any) => {
        console.error('Error loading tasks: ', err);
        this.selectedTasks = [];
      }
    });
  }

  async loadAsignedVehicle(id: number) {
    this.tasks.getVehicles({ page: 1, per_page: 100, assignee_id: id }).subscribe({
      next: (data: any) => {
        console.log('vehicle => ', data);
        this.vehicle = data.data[0];
      },
      error: (error: any) => {
        console.log('error => ', error);
        this.vehicle = {};
      }
    });
  }

  async loadSkills(id: number) {
    this.tasks.getSkills({ user_id: id }).subscribe({
      next: (data: any) => {
        this.skills = data;
      },
      error: (error: any) => {},
    });

    this.tasks.getUserSkills(id).subscribe({
      next: (data: any) => {
        console.log('asignedSkills => ', data);
        this.asignedSkills = data;
      },
      error: (error: any) => {
        console.log('error => ', error);
        this.asignedSkills = [];
      }    
    });
  }

  loadWorkSchedule(id: number) {
    this.tasks.getWorkHour(id).subscribe({
      next: (data: any) => {
        console.log('work_schedule => ', data);
        this.work_schedule = data;
      },
      error: (error: any) => {}
    });
  }

  async loadTools(id: number) {
    this.tasks.getTools({ assignee_id: id }).subscribe({
      next: (data: any) => {
        console.log('tools => ', data.data);
        this.tools = data.data;
      },
      error: (error: any) => {}
    });
  }

  async loadStats(id: number) {
    console.log('loadStats ===========> ', id);
    this.tasks.getTechStatSummary(id).subscribe((summary: any) => {
      console.log('summary => ', summary);
      this.summary = summary;
    });
  }

  loadTechStats(query: any) {
    this.tasks.getTechStatsSummary(query).subscribe(async (data: any) => {
      console.log('summary ==> ', data);
      this.grades = data;
    });
  }

  search() {
    this.loadTechStats(this.query);
  }

  pageChanged(event: any) {
    console.log('pageChanged => ', event);
    this.payload.page = event;
    this.loadUsers(this.payload);
  }

  taskPageChanged(event: any) {
    console.log('taskPageChanged => ', event);
    // this.payload.page = event;
    this.task_config.page = event;
    this.loadTasks(this.selectedTechnician.id);
  }

  removeUser(id: number) {
    this.store.destroyUser(id).subscribe({
      next: (data: any) => {
        this.toastr.success('Usuario eliminado correctamente.', 'Éxito');
        this.loadUsers(this.payload);
      },
      error: (err: any) => {
        this.toastr.error('Ocurrió un error al eliminar el usuario.', 'Error');        
      },
    });
  }

  updateVehicle(vehicle: any) {
    this.tasks.updateAssignedVehicle(vehicle.vehicle_id, vehicle).subscribe({
      next: (data: any) => {
        console.log('data => ', data);
        this.toastr.success('Éxito', 'Vehículo actualizado correctamente.');
        this.loadAsignedVehicle(this.selectedTechnician.id);
      },
      error: (error: any) => {
        console.log('error => ', error);
        this.toastr.error('Error', 'Ocurrió un error al actualizar el vehículo');
      }
    });
  }

  setPeriod(event: any) {
    console.log('event ==> ', event.target.value);
    this.period = event.target.value;
  }

  editSchedule() {
    const modalTemplate: any | undefined = this.modalWorkScheduleComponent['modalWorkSchedule']; // Reference modal template in child
    if (modalTemplate) {
      this.modalWorkScheduleComponent.openModal(modalTemplate);
    }
  }

  addTools() {
    const modalTemplate: any | undefined = this.modalToolsComponent['modalTools']; // Reference modal template in child
    if (modalTemplate) {
      this.modalToolsComponent.openModal(modalTemplate);
    }
  }

  addVehicle() {
    const modalTemplate: any | undefined = this.modalVehiclesComponent['modalVehicle']; // Reference modal template in child    
    if (modalTemplate) {
      this.modalVehiclesComponent.openModal(modalTemplate);
    }
  }

  addSkills() {
    const modalTemplate: any | undefined = this.modalSkillsComponent['modalSkills']; // Reference modal template in child    
    if (modalTemplate) {
      this.modalSkillsComponent.openModal(modalTemplate);
    }
	}

  updateUser() {
    const modalTemplate: any | undefined = this.modalUserFormComponent['modalUserForm']; // Reference modal template in child
    if (modalTemplate) {
      this.modalUserFormComponent.openModal(modalTemplate);
    }
  }

  createUser() {
    const modalTemplate: any | undefined = this.modalUserFormComponent['modalUserForm']; // Reference modal template in child
    if (modalTemplate) {
      this.modalUserFormComponent.openModal(modalTemplate);
    }
  }

  updatePassword() {
    const modalTemplate: any | undefined = this.modalUserPasswordComponent['modalUserPassword']; // Reference modal template in child
    if (modalTemplate) {
      this.modalUserPasswordComponent.openModal(modalTemplate);
    }
  }

  updateDismissed() {
    this.selectTechnician(this.selectedTechnician);
  }

  updateFilter(mes: number) {
      const today = new Date();
      today.setMonth(today.getMonth() - mes);
      const adjustedDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      const testDate = new Date(this.a.getFullYear(), 1, 15); // February 15, 2025 (months are 0-indexed)
      const lastDay = new Date(testDate.getFullYear(), testDate.getMonth() + 1, 0);
  
      this.fromDate = new NgbDate(adjustedDate.getFullYear(), adjustedDate.getMonth()+1, 1);
      this.toDate = new NgbDate(this.a.getFullYear(), this.a.getMonth()+1, lastDay.getDate());
  
      this.query.date_from = `${this.fromDate?.year}-${this.fromDate?.month}-${this.fromDate?.day}`;
      this.query.date_to = `${this.toDate?.year}-${this.toDate?.month}-${this.toDate?.day}`;
  
      this.loadTechStats(this.query);
  
      if (mes == 1) {
        this.oneMonth.nativeElement.classList.add('active');
        this.threeMonth.nativeElement.classList.remove('active');
        this.sixMonth.nativeElement.classList.remove('active');
        this.twelveMonth.nativeElement.classList.remove('active');
      }
      if (mes == 3) {
        this.oneMonth.nativeElement.classList.remove('active');
        this.threeMonth.nativeElement.classList.add('active');
        this.sixMonth.nativeElement.classList.remove('active');
        this.twelveMonth.nativeElement.classList.remove('active');
      }
      if (mes == 6) {
        this.oneMonth.nativeElement.classList.remove('active');
        this.threeMonth.nativeElement.classList.remove('active');
        this.sixMonth.nativeElement.classList.add('active');
        this.twelveMonth.nativeElement.classList.remove('active');
      }
      if (mes == 12) {
        this.oneMonth.nativeElement.classList.remove('active');
        this.threeMonth.nativeElement.classList.remove('active');
        this.sixMonth.nativeElement.classList.remove('active');
        this.twelveMonth.nativeElement.classList.add('active');
      }
  
    }

  async downloadReport() {

    this.downloading = true;
    const options = {
      title: 'Reporte de calificaciones de tareas',
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: true,
      noDownload: false,
      showTitle: true,
      useBom: true,
      headers: ['Tarea', 'Calificación', 'Fecha', 'Condominio', 'Completada']
    };

    const calificaciones: any[] = [];
    await this.grades.map((grade: any) => {
      calificaciones.push({
        'Id': grade.task?.id,
        'Tarea': grade.task?.name,
        'Calificación': grade.avg_grade,
        'Fecha': grade.task?.due_date.split('T')[0],
        'Condominio': grade.settlement?.name,
        'Completada': grade.task?.completed_at
      });
    });

    await new ngxCsv(calificaciones, 'reporte-tecnico', options);
    this.downloading = false;
  }

}
